import React from 'react';
import { alexforbesBrand } from '../brand/alexforbes';

/**
 * Transparent wordmark / mark (light grey text + teal/orange chart icon).
 * variant="mark" — icon only (login card, collapsed sidebar).
 */
const BrandLogo = ({ variant = 'wordmark', className = '', style = {} }) => {
  const useMark = variant === 'mark' || variant === 'sidebarCollapsed';

  const heights = {
    mark: 64,
    login: 52,
    wordmark: 48,
    sidebar: 32,
    sidebarCollapsed: 28,
    header: 40,
    report: 44,
  };

  const height = heights[variant] ?? heights.wordmark;

  return (
    <img
      className={`af-brand-logo af-brand-logo--${variant} ${className}`.trim()}
      src={useMark ? alexforbesBrand.logoMarkPath : alexforbesBrand.logoPath}
      alt={alexforbesBrand.logoAlt}
      style={{
        height,
        width: 'auto',
        maxWidth: '100%',
        objectFit: 'contain',
        display: 'block',
        ...style,
      }}
    />
  );
};

export default BrandLogo;
